// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"f1e7b8f197d81990","931":"b161dcd74afc8b1a"}[chunkId] + ".css";
};